export default __webpack_public_path__ + "static/company-website-2-47b32818ebc96ce7e4595d04bf3d2b2a.png";